import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import axios from 'axios';

const View = ({ show, onClose, datas }) => {


  return (
    <Modal show={show} size="md">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <div className='d-flex align-items-center gap-3 flex-wrap'>
            <h3 className="modal-title text-white">Mobile Number Verification Details</h3>
          </div>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Lead</label>
              <label className='text-black fs-6 font-w500'>{datas.lead_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
              <label className='text-black fs-4 font-w500 fw-bold'>{datas.mobile_no}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Status</label>
              <label className={`fs-6 font-w500 text-break ${datas.is_valid_mobile === 1 ? 'text-success' : 'text-danger'}`}>{datas.is_valid_mobile === 1 ? 'Valid Number' : 'IN-Valid Number'}</label>
            </div>

            {datas.is_valid_mobile === 1 && (
              <>
                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                  <label className='text-gray-800 font-w500 fs-7'>Carrier</label>
                  <label className='text-black fs-6 font-w500'>{datas.mobile_carrier ? datas.mobile_carrier : '-'}</label>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                  <label className='text-gray-800 font-w500 fs-7'>Line Type</label>
                  <label className='text-black fs-6 font-w500'>{datas.mobile_line_type ? datas.mobile_line_type : '-'}</label>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                  <label className='text-gray-800 font-w500 fs-7'>Location</label>
                  <label className='text-black fs-6 font-w500'>{datas.location ? datas.location : '-'}</label>
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </Modal >
  );
};

export default View;
